import React from "react";
// v1 imports - commented out for v2 redesign
// import Sidebar from "react-sidebar";
// import SideBarContent from "./SideBarContent";
// import "../../styles/sidebar/sidebar.css";
// import { sidebarSelector, toggleSideBar } from "../../redux/reducers/sidebar";
// import { useDispatch, useSelector } from "react-redux";
// import useIsMobile from "../../hooks/isMobile";

// v2 import
import SideBarV2 from "../../components-v2/SideBar/SideBarV2";

const SideBar = ({ children }) => {
  // v1 implementation - commented out for v2 redesign
  // const dispatch = useDispatch();
  // const isMobile = useIsMobile();
  // const isOpen = useSelector(sidebarSelector);

  // function handleChange() {
  //   try {
  //     dispatch(toggleSideBar(!isOpen));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  // return (
  //   <Sidebar
  //     sidebar={<SideBarContent />}
  //     open={isOpen}
  //     docked={!isMobile && isOpen}
  //     overlayClassName="sidebar-overlay"
  //     sidebarClassName="sidebar"
  //     onSetOpen={handleChange}
  //   >
  //     <div className="children-wrapper">{children}</div>
  //   </Sidebar>
  // );

  // v2 implementation
  return <SideBarV2>{children}</SideBarV2>;
};

export default SideBar;
